import { render, staticRenderFns } from "./MTabBar.vue?vue&type=template&id=7faf1388&"
import script from "./MTabBar.vue?vue&type=script&lang=js&"
export * from "./MTabBar.vue?vue&type=script&lang=js&"
import style0 from "./MTabBar.vue?vue&type=style&index=0&id=7faf1388&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports